import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from './Button';
import ServiceShowcase from './ServiceShowcase';
import { BRAND, brandify } from '../brandConfig';

const SocialMediaPage = ({ navigate }) => {
  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen flex flex-col justify-between">
      <Helmet>
        <title>{`Social Media Marketing Services | ${BRAND}`}</title>
        <meta name="description" content={brandify('Wind Marketing manages multi-channel social media strategies that build communities, drive engagement, and convert followers into customers. Social media marketing that moves.')} />
        <meta name="keywords" content={`social media marketing agency, social media management, content creation agency, social media strategy, ${BRAND} social media`} />
        <link rel="canonical" href="https://www.wind-marketing.com/social-media" />
        <meta property="og:title" content={`Social Media Marketing Services • ${BRAND}`} />
        <meta property="og:description" content={brandify('Wind Marketing manages multi-channel social media strategies that build communities and convert followers into customers.')} />
        <meta property="og:url" content="https://www.wind-marketing.com/social-media" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Social Media Marketing",
            "provider": {
              "@type": "Organization",
              "name": "${BRAND}",
              "url": "https://www.wind-marketing.com"
            },
            "description": "${brandify('Multi-channel social media strategy, content creation, and community management for growth-stage businesses. Wind Marketing engineers active communities and owns brand conversations across all platforms.')}",
            "url": "https://www.wind-marketing.com/social-media",
            "serviceType": "Social Media Marketing",
            "areaServed": "Worldwide"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What social media platforms does ${BRAND} manage?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify('Wind Marketing manages multi-channel social media campaigns across all major platforms including Instagram, LinkedIn, YouTube, TikTok, X (Twitter), and Facebook. Strategy is tailored to where your specific audience is most active.')}"
                }
              },
              {
                "@type": "Question",
                "name": "Does ${BRAND} create content for social media?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify('Yes. Wind Marketing provides end-to-end content creation including copywriting, graphic design, and video content — all engineered to stop the scroll and drive measurable engagement.')}"
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      {/* Main Content Area */}
      <div className="max-w-4xl mx-auto mt-12 mb-20 flex-grow w-full">
        {/* Breadcrumb / Back button */}


        {/* Header Section */}
        <div className="w-full mb-27">
          <h1 
            className="text-4.5xl whitespace-nowrap sm:text-6xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-none mb-8 text-foreground"
            style={{ fontFamily: "'Poppins Black', sans-serif" }}
          >
            SOCIAL MEDIA
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-medium">
            Social media isn't just about sharing updates; it's about engineering active communities and owning conversations. We handle the strategy, content creation, and scheduling for your Facebook or Instagram. We offer hands-free posting that delivers engaging content and keeps your audience connected. Check our work below.
          </p>
        </div>

        <ServiceShowcase currentPath="/social-media" navigate={navigate} />

        {/* Interactive Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12">
          <Button
            size="large"
            onClick={() => {
              navigate('/pricing');
              setTimeout(() => {
                document.getElementById('social-pricing')?.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
          >
            Let's Get Started!
          </Button>
          <Button 
            variant="outline" 
            size="large"
            onClick={() => navigate('/work')}
          >
            OUR SERVICES
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaPage;
